import produce from 'immer';

import * as types from './types';
import * as projects from '../projects/types';

import filterFiles from '../../utility/filterFiles';
import findInFileArray from '../../utility/findInFileArray';
import findInFileChildren from '../../utility/findInFileChildren';
import fileArrayToTree from '../../utility/fileArrayToTree';
import searchFiles from '../../utility/searchFiles';
import { checkPropTypes } from 'prop-types';

const initialState = {
  dataFactoryList:[],
  dFTable:[]
}

const reducer = (state = initialState, action) =>
  produce(state, draft => {
    switch (action.type) {
      case types.PREVIEW_FILE_SUCCESS: {
        const { file, projectId } = action.meta;
        const project = draft[projectId];

        project.selectedFile = { ...file, src: action.payload };
        break;
      }
      case types.REVIEW_FILE_SUCCESS: {
        const { file, projectId } = action.meta;
        const project = draft[projectId];

        project.selectedFile = {
          ...file,
          src: action.payload.src,
          tgt: action.payload.tgt,
          disc: action.payload.disc,
          rpt: action.payload.rpt
        };
        break;
      }
      case types.VIEW_REPORT_SUCCESS: {
        const { projectId } = action.meta;
        const project = draft[projectId];
        project.report = action.payload;
        break;
      }
      case projects.CREATE_PROJECT_SUCCESS: {
        draft[action.payload.projectId] = action.payload;
        break;
      }
      case projects.EDIT_PROJECT_SUCCESS: {
        draft[action.payload.projectId] = action.payload;
        break;
      }
      case projects.DELETE_PROJECT_SUCCESS: {
        delete draft[action.meta.projectId];
        break;
      }
      case projects.GET_PROJECTS_SUCCESS: {
        action.payload.projects.forEach(each => {
          draft[each.projectId] = each;
        });
        break;
      }
      case projects.GET_PROJECT_FILES_SUCCESS: {
        draft[action.meta.projectId].files = fileArrayToTree(
          action.payload.files
        );
        break;
      }
      case types.TRANSLATE_FILES_SUCCESS: {
        draft[action.meta.projectId].reportId = action.payload.reportId;
        draft[action.meta.projectId].selectedFile = null;
        break;
      }
      case projects.SELECT_PROJECT: {
        draft[action.project.projectId] = action.project;
        break;
      }
      case types.TOGGLE_FILE: {
        const project = draft[action.project.projectId];
        const file = findInFileArray(project.files, action.file.fileId);
        if (file) file.open = !file.open;

        if (project.filteredFilesList) {
          const filteredFile = findInFileArray(
            project.filteredFilesList,
            action.file.fileId
          );
          if (filteredFile) filteredFile.open = file.open;
        }
        break;
      }
      case types.SELECT_FILE: {
        const project = draft[action.project.projectId];
        const { files } = project;
        const file = findInFileArray(files, action.fileId);
        file.selected = !file.selected;
        findInFileChildren(file, childElement => {
          childElement.selected = file.selected;
        });

        if (draft[action.project.projectId].searchResults) {
          for (const f of draft[action.project.projectId].searchResults) {
            if (f.fileId === action.fileId) f.selected = action.selected;
          }
        }

        const newFilesListArray = JSON.parse(JSON.stringify(files));
        draft[action.project.projectId].filteredFilesList = filterFiles(
          newFilesListArray
        );

        break;
      }
      case types.findByProjectName_SUCCESS:
      return{
        ...state,
        projectModel:action.payload.data
      }
      case types.dataFactoryList_SUCCESS:
      return {
        ...state,
        dataFactoryList: action.payload.data
      }
      case types.dataFactoryTable_SUCCESS:
      return {
        ...state,
        dFTable: action.payload.data
      }
      case types.SEARCH_FILES: {
        if (!action.searchTerm || action.searchTerm.trim().length === 0) {
          draft[action.projectId].searchResults = null;
          break;
        }
        draft[action.projectId].searchResults = draft[
          action.projectId
        ].files.reduce((total, file) => {
          const fileArray = searchFiles(file, action.searchTerm);
          return [...total, ...fileArray];
        }, []);
        break;
      }
      default:
    }
  });

export default reducer;



// WEBPACK FOOTER //
// ./src/state/project/reducer.js